module.exports = __webpack_public_path__ + "img/dscvry_logo_D_light-grey.b15bce44.png";